import fetchQuery from 'rebook/apps/utils/fetchQuery';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import * as Error404Actions from 'rebook/apps/base/actions/Error404Actions';
import {
  BOOKS_BOOK_AUTHORS_SET_DATA,
  BOOKS_BOOK_AUTHORS_RESET_DATA,
} from 'rebook/apps/books/constants';
import { Book } from 'rebook/apps/books/models';


export function fetchInitialData(match, location = {}) {
  return async(dispatch, getState) => {
    const currentState = getState().bookAuthorList;
    let newState = {};
    if (location && location.state) {
      newState = {
        ...newState,
        ...location.state,
      };
    }
    if (currentState.book) {
      newState = {
        ...newState,
        ...currentState,
      };
    }

    // set partial state (it could probably be the data obtained from router)
    dispatch(setData(newState));

    if (!newState.book) {
      await dispatch(fetchBook(match));
    }
  };
}

export function fetchBook(match) {
  return async(dispatch, getState) => {
    const { ssr } = getState();
    const { bookSlug } = match.params;
    const url = `/api/books/s-${bookSlug}/`;
    return await fetchQuery(url, { apiVersion: 4, headers: ssr.headers })
      .then(({ data }) => {
        dispatch(setData({ book: data }));
      })
      .catch(({ data, resp, error }) => {
        if (resp.status === 404) {
          dispatch(Error404Actions.show());
        }
        else {
          Raven.captureMessage('failed to load book author list book due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
              error,
            },
          });
          throw new Error('failed to load book author list book detail due to server error');
        }
      });
  };
}

function setSeoMeta() {
  return (dispatch, getState) => {
    const { bookAuthorList, booksPerSubscriptionCounter } = getState();
    const book = new Book(bookAuthorList.book);
    const title = `Все авторы книги ${book.name}`;
    const description = `Все авторы книги ${book.name} ` +
                        `Читайте эту и еще ${booksPerSubscriptionCounter.total} ` +
                        `книг по подписке на iPhone, iPad, Android`;
    dispatch(SeoActions.setData({
      title,
      description,
    }));
  };
}

export function setData(payload) {
  return (dispatch) => {
    const { book } = payload;
    dispatch({
      type: BOOKS_BOOK_AUTHORS_SET_DATA,
      payload,
    });
    if (book) {
      dispatch(setSeoMeta());
    }
  };
}

export function resetData() {
  return (dispatch) => {
    dispatch(SeoActions.resetData());
    dispatch({
      type: BOOKS_BOOK_AUTHORS_RESET_DATA,
    });
  };
}
